import _ from 'lodash';
import React from 'react';

export default function TextNewLineToBr({ string = '' }: { string: string }) {
  const list = string.replace(/(?:\r\n|\r|\n)/g, '<breaky-breaky>').split('<breaky-breaky>');
  return <> {_.flatMap(list, (string, i) => [<span key={'span-' + i}>{string}</span>, <br key={'br-' + i} />])}</>;
}
